import React from 'react'
import { useSelector } from'react-redux'
import { isEverit } from './check-org'
export default function Logo() {
    const user = useSelector((state) => state?.user?.userData?.user);
    if(isEverit(user?.OrganizationId)) return <img src="/assets/img/everit-logo.png" style={{ width: "180px", marginTop: 20 }} />
    return <img src="/assets/svg/logo.svg" style={{ width: "180px" }} />
}
